import React from "react";
import preOrderCard from "../components/pre-order-card.png";
import { StoreCardForPack } from "../../../components/store-card/store-card-for-pack";
import AutoConfirmTimeline from "./pre-order-timeline/auto-confirm-timeline";
import CanceledTimeline from "./pre-order-timeline/canceled-timeline";
import EarlyConfirmTimeline from "./pre-order-timeline/early-confirm-timeline";
import { formatDateToYearMonthDayDayOfWeek } from "../../../utils/date/format-date";

const PreOrderGuide: React.FC = () => {
  return (
    <>
      {/* 메인 히어로 섹션 */}
      <div className="relative aspect-[940/768] overflow-hidden">
        <img
          src={preOrderCard}
          alt="예약팩 이용 안내"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4 w-full">
          <h2
            className="font-bold text-gray-900 leading-tight"
            style={{ fontSize: "calc(100vw * 0.074)" }}
          >
            가격은 가볍게, 구성은 든든하게
          </h2>
          <p className="mt-1 font-medium text-xl text-gray-700">
            미리 주문하고 예약시간에 픽업하기
          </p>
          <div className="flex mt-1.5">
            <div className="bg-green-100 text-green-600 text-lg px-2 py-1 rounded-full border-2 border-green-600 font-bold">
              예약팩
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6 p-2">
        {/* 01. 예약팩이란? */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">01.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              예약팩이란?
            </span>
          </div>
          <div className="space-y-1">
            <p className="text-gray-700 text-md break-keep">
              예약팩은 미리 주문하고 주문이 확정되면, 매장 픽업시간에 수령하는
              서비스예요.
            </p>
            <p className="text-gray-700 text-md break-keep">
              마감 시간까지{" "}
              <span className="font-semibold">
                당일 생산·판매 상황이 항상 달라지기 때문에
              </span>
              , 예약팩은 픽업 직전에 준비된 상품으로 즉,{" "}
              <span className="font-semibold text-green-600">랜덤</span>으로
              담겨요.
            </p>
          </div>
        </section>

        {/* 02. 가게를 찾고 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">02.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              가게를 찾고
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            예약팩이 오픈된 가게를 찾아요
          </p>
          <div className="pointer-events-none bg-gray-50 p-4 border rounded-lg">
            <StoreCardForPack
              quantity={3}
              title="치즈 베이커리"
              discountPrice={4900}
              price={10000}
              onClick={() => {}}
              onClickHeart={() => {}}
              img="https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif"
              isLiked={false}
              distance={1}
              disableLike={false}
              reserveTime="오늘 19:00 ~ 20:00"
              tomorrowReserveTime="내일 18:00"
              likeCount={100}
              exposeType="오늘"
            />
          </div>
        </section>

        {/* 03. 픽업 가능하면 구매 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">03.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              픽업이 가능하면 구매해요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            픽업 시간을 확인하고 주문해요
          </p>

          {/* 요약 카드 */}
          <div className="flex flex-col space-y-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col bg-white rounded-xl p-4">
                <div className="text-black text-md font-semibold">
                  남은 개수
                </div>
                <div className="text-gray-700 text-xl font-semibold">3</div>
              </div>
              <div className="flex flex-col bg-white rounded-xl p-4">
                <div className="text-black text-md font-semibold">가격</div>
                <div className="text-xl font-semibold flex flex-col gap-1">
                  <span className="line-through text-gray-400 text-md">
                    10,000원 어치
                  </span>
                  <span className="text-green-600">4,900원</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col bg-white rounded-xl p-4 gap-1.5">
              <div className="flex items-center gap-3">
                <div className="text-gray-600 text-md font-semibold">
                  픽업시간
                </div>
                <div className="text-green-600 text-md font-semibold">
                  오늘 19:00 ~ 20:00
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="text-gray-600 text-md font-semibold">
                  확정시간
                </div>
                <div className="text-red-500 text-md font-semibold">18:30</div>
              </div>
              <div className="text-gray-600 text-xs">
                * 예약은 한 시간 전(18:00)까지만 가능해요
              </div>
            </div>

            <div className="flex flex-col bg-white rounded-xl p-4">
              <div className="text-gray-600 text-md font-semibold">팩 설명</div>
              <div className="text-gray-800 text-base font-semibold">
                치즈가 들어간 빵을 판매해요. 주로 치즈 크로와상, 치즈 샌드위치,
                치즈 케익이 들어가요.
              </div>
            </div>
          </div>
        </section>

        {/* 04~05. 확정 진행(메인: 자동확정) */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-green-500 font-bold text-3xl">04.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              확정은 이렇게 진행돼요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            확정 알림을 받으면 가게의 픽업시간에 픽업하러 가요!
          </p>

          {/* 메인 플로우: 자동확정 */}
          <div className="rounded-lg p-4 border border-gray-200">
            <div className="mb-2 font-semibold text-gray-900">자동확정</div>
            <AutoConfirmTimeline />
            <ul className="text-md text-gray-500 mt-3 list-disc pl-5 space-y-1">
              <li>픽업 시작 30분 전까지 확정이 안 되면 자동으로 확정돼요</li>
            </ul>
          </div>
        </section>

        {/* 06. 픽업 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">05.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              픽업시간을 꼭 지켜서 상품을 픽업해요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            매장의 픽업시간은{" "}
            <span className="font-bold">주문내역 &gt; 상세보기</span>에서 확인할
            수 있어요.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 space-y-2 pt-4 border border-gray-200">
            <div className="pb-4">
              <div className="text-center space-y-1">
                <div className="text-xl font-black text-gray-900 tracking-wide">
                  {formatDateToYearMonthDayDayOfWeek(new Date())}
                </div>
                <div className="text-2xl font-black text-primary tracking-wide">
                  19:00 ~ 20:00
                </div>
              </div>
            </div>
            <div className="p-4 bg-primary/90 rounded-lg">
              <div className="text-center space-y-3">
                <p className="text-xl font-medium break-keep text-white text-center">
                  <span className="font-black tracking-wider underline underline-offset-4">
                    꼭 픽업시간에 맞춰
                  </span>{" "}
                  픽업을 해주세요!
                </p>

                <div className="flex flex-col gap-1">
                  <p className="text-lg text-white font-medium">
                    만약{" "}
                    <span className="font-black tracking-wider">
                      조기확정 알림
                    </span>
                    을 받았다면
                  </p>
                  <p className="text-lg text-white font-medium">
                    지금부터 픽업이 가능해요!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-gray-600 flex justify-end mt-2">
            <p className="text-sm font-bold">[ 주문내역 &gt; 상세보기 ]</p>
          </div>
        </section>

        {/* 07. 주문코드 제시 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">06.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              주문코드를 직원에게 보여주세요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            <span className="font-bold">주문내역 &gt; 상세보기</span>에서{" "}
            <span className="font-bold">주문코드</span>를 확인하고 매장 직원에게
            보여주세요.
          </p>

          {/* 주문코드 예시 */}
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-700">주문 코드</span>
                <span className="text-lg font-bold text-blue-600">
                  용감한 히어로
                </span>
              </div>
              <div className="border-t border-gray-200 pt-3">
                <div className="flex items-start bg-white rounded-lg border-b last:border-none p-2">
                  <img
                    src="https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif"
                    alt="치즈 베이커리"
                    className="w-[120px] h-[120px] object-cover rounded-lg"
                  />
                  <div className="ml-3 flex flex-col flex-1">
                    <p className="font-bold text-gray-900 mb-1">
                      치즈 베이커리 랜덤팩
                    </p>
                    <p className="text-gray-700">1개 구매</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-gray-600 flex justify-end mt-2">
            <p className="text-sm font-bold">[ 주문내역 &gt; 상세보기 ]</p>
          </div>
        </section>

        {/* 08. 직원 픽업 완료 처리 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">07.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              직원이 픽업 완료 버튼을 눌러요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            매장에서 상품을 받고 직원이 픽업 완료 처리를 해요.
          </p>

          <div className="text-center bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex flex-col items-center">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={true}
                  readOnly
                />
                <div className="w-[138px] h-16 rounded-full shadow-inner transition-colors duration-300 bg-green-500"></div>
                <div className="absolute w-12 h-12 bg-white rounded-full shadow-lg transform transition-transform duration-300 ease-in-out translate-x-[82px]"></div>
              </label>

              <div className="text-gray-900 text-base font-bold mt-2">
                직원 확인 버튼
              </div>
              <div className="text-md text-gray-700">
                이 화면을 직원에게 보여주시고 눌러달라고 해주세요
              </div>
            </div>
          </div>
        </section>

        {/* 예외/변동 케이스 모아보기 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-green-500 font-bold text-3xl">08.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              그 외의 경우
            </span>
          </div>

          {/* 조기확정 */}
          <div className="bg-white rounded-lg p-4 border border-gray-200 mt-3">
            <div className="mb-2 font-bold text-blue-600">조기확정</div>
            <p className="text-md text-gray-600 mb-3 break-keep">
              재고/상황에 따라 자동확정 이전에 확정될 수 있어요. 확정 시점부터
              픽업시간까지 방문 가능해요.
            </p>
            <EarlyConfirmTimeline />
            <ul className="text-md text-gray-700 mt-3 list-disc pl-5 space-y-1">
              <li>조기확정 알림이 오면 그때부터 바로 픽업이 가능해요.</li>
            </ul>
          </div>

          {/* 취소 */}
          <div className="bg-white rounded-lg p-4 border border-gray-200 mt-3">
            <div className="mb-2 font-bold text-red-600">취소</div>
            <p className="text-md text-gray-600 mb-3 break-keep">
              가게 사정(조기 마감, 품절 등)으로 픽업이 어려운 경우 주문이 취소될
              수 있어요. 취소 시 앱과 카카오톡으로{" "}
              <span className="font-bold">즉시 안내</span>해 드려요.
            </p>
            <CanceledTimeline />
            <ul className="text-md text-gray-700 mt-3 list-disc pl-5 space-y-1">
              <li>
                취소 알림을 받으면 결제는 자동으로 환불 처리돼요. (환불은 영업일
                기준 최대 1-2일 걸릴 수 있어요.)
              </li>
            </ul>
          </div>
        </section>

        <section className="px-4 pb-8">
          <a
            href="http://pf.kakao.com/_xawxcRn/chat"
            className="w-full bg-primary text-white font-semibold py-3 px-6 rounded-lg flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg"
          >
            <span>💬</span>
            문의사항이 있으신가요?
          </a>
        </section>
      </div>
    </>
  );
};

export default PreOrderGuide;
